
import React, { Component } from 'react';
import ApplyCSS from './../../../../../../components/ApplyCSS';
import commonUtil from './../../../../../../utils/commonUtil';

const pageName = 'contract';
const channel = commonUtil.getChannel();

class ContractPageForDownloadPDF extends Component {

  formatDate = (date) => {
    let formattedDate = "";
    if (date && typeof date === "string" && date.includes("-")) {
        const [year, month, day] = date.split("-");
        if (year && month && day) {
            formattedDate = `${day}/${month}/${year}`;
        }
    }

    return formattedDate;
  }
  
  render() {
    const { userAllData, contractDetails } = this.props; // eslint-disable-line no-shadow
    let currentDate = new Date();
    let day = String(currentDate.getDate()).padStart(2, '0');
    let month = String(currentDate.getMonth() + 1).padStart(2, '0');
    let year = currentDate.getFullYear();
    
    let formattedDate = `${day}/${month}/${year}`;

    return (
      <div className="toPrint">
        <ApplyCSS pageName={pageName} />
        <div className="p-t-20 contractPdfHeader">
          <div><b>Festejados:</b>{userAllData && userAllData.eventDate && userAllData.eventDate.celebrityInfo && userAllData.eventDate.celebrityInfo.length > 0 ?
            userAllData.eventDate.celebrityInfo.map(data => (<span>{data.firstName} {data.lastName}&lt;{data.hasPermission ? data.email : ''}&gt;</span>))
            :
            null}</div>
          <div><b>Fecha del evento:</b><span>{userAllData.eventDate.eventDate ? this.formatDate(userAllData.eventDate.eventDate) : null}</span></div>
          <div><b>Tipo de evento:</b><span>{userAllData.eventDate.eventType}</span></div>
          <div><b>Numero de evento:</b><span>{userAllData.eventDate.eventId}</span></div>
          <div><b>Fecha de creacion del evento:</b><span>{formattedDate}</span></div>
          <div><b>Direcciones:</b>{userAllData && userAllData.addresses && userAllData.addresses.length > 0 ? userAllData.addresses.map(data => (<span>{data.address1}&sbquo;{data.neighbourhood}&sbquo;{data.delegationMunicipality}&sbquo;{data.city} &sbquo;{data.state}&sbquo;{data.postalCode}&sbquo;{data.country}</span>))
            :
            null}</div>
          {/* <div><b>Evento de empleado</b></div>
          <div><b>Tarjetas asignadas:</b><span /></div> */}
        </div>
        {channel === 'wap' ?
          <div className="innerWrap contractWrapper">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 col-xs-12 col-xs-offset-0" id="contract">
                {/* <h2 className="titleMesa">Mesa de regalos</h2> */}
                <h1 className="titleSection m-b-30">Contrato para la mesa de regalos Livepool</h1>
                <p className="subtitleModule">Contrato para la mesa de regalos de Liverpool</p>
                <div className="container">
                  {(contractDetails) ?
                    <div className="dummyPdfContent container" dangerouslySetInnerHTML={{ __html: contractDetails }} />
                    :
                    <h4>Data not Available in service</h4>}
                </div>
              </div>
            </div>
          </div>
          :
          // <div className="innerMain">
          //   <h1 className="titleSection text-center m-b-30">Contrato para la mesa de regalos Livepool</h1>
          //   {/* <p className="subtitleModule">Contrato para la mesa de regalos Livepool</p> */}
          //   <div className="container">
          //     <p className='ml-25'>Contrato para la mesa de regalos de Liverpool</p>
          //     {(contractDetails) ?
          //       <p className="textAlignParagraphContract" dangerouslySetInnerHTML={{ __html: contractDetails }} />
          //       :
          //       <h4>Data not Available in service</h4>}
          //   </div>
          // </div>
          <div className="container pageAlignContract">
            <div className="">
              <h1 className="text-center m-b-30">Contrato para la mesa de regalos Livepool</h1>
            </div>
            <h5 className="">Contrato para la mesa de regalos de Liverpool</h5>
            <div className="">
              {(contractDetails) ?
                <p className="textAlignParagraphContract" dangerouslySetInnerHTML={{ __html: contractDetails }} />
                :
                <h4>Data not Available in service</h4>}
            </div>
          </div>
        }
      </div>
    );
  }
}

export default ContractPageForDownloadPDF;
